import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M10 1.667A8.326 8.326 0 001.667 10 8.326 8.326 0 0010 18.333 8.326 8.326 0 0018.333 10 8.326 8.326 0 0010 1.667z" fill="#54585D" /></svg>);